import createReactClass from "create-react-class";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import {
  AutoSizer,
  Column,
  SortDirection,
  SortIndicator,
  Table,
} from "react-virtualized";
import { AdminActions } from "../../actions/adminActions";
import { ServerActions } from "../../actions/serverActions";
import { adminStore } from "../../stores/adminStore";
import { subdivisionStore } from "../../stores/subdivision";
import { ContentBox } from "./ContentBox";

import "../../css/adminScreen.css";
import { withRouter } from "../../util/withRouter";

var successMsg = "";
// Load state from the stores
function getStateFromStores() {
  return {
    itemType: adminStore.getItemType(),
    isLoading: adminStore.isLoading(),
    items: adminStore.getItems(),
    loadingError: adminStore.getError(),
    subdivisions: subdivisionStore.getEntireSubList(),
    disableHeader: false,
    useDynamicRowHeight: false,
    rowCount: 10,
    scrollToIndex: undefined,
    height: 325,
    rowHeight: 23,
    headerHeight: 30,
    overscanRowCount: 10,
    hideIndexRow: false,
    sortBy: "name",
    sortDirection: SortDirection.ASC,
    filteredData: adminStore.getItems(),
    reason: "",
    reasonDescription: "",
    oldReason: "",
    oldReasonDescription: "",
    defaultID: 0,
    alertVisible: false,
    alertMessage: "",
    formAFlag: "",
    formBFlag: "",
    formARejectFlag: "",
    formBRejectFlag: "",
    overrideFlag: "",
    activeRestrictionCode: true,
    rejectReasonId: [],
    defaultChecked: true,
    successUpdated: "",
  };
}

let adminTimerInterval= null;

const ReasonCodeAdminComponent = createReactClass({
  componentDidMount: function () {
    $("#mainSchematic").empty();
    adminStore.subscribe(this._onChange);
    subdivisionStore.subscribe(this._onChange);
    AdminActions.setItemType(this.props.location.pathname);
    AdminActions.loadItems();
    ServerActions.getSubdivisionList();
    adminTimerInterval = setInterval(this.refresh, 1000);
  },

  componentWillUnmount: function () {
    adminStore.unsubscribe(this._onChange);
    subdivisionStore.unsubscribe(this._onChange);
    clearInterval(adminTimerInterval);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  refresh: function () {
    this.setState({});
  },
  // Sort function for the default track data table
  _sort({ sortBy, sortDirection }) {
    const comparer = (a, b) => {
      if (sortBy == "activeRestrictionCode") {
        if (sortDirection === "ASC") {
          if (
            (a[sortBy] + "").toString().toUpperCase() >
            (b[sortBy] + "").toString().toUpperCase()
          ) {
            return 1;
          } else if (
            (a["reason"] + "").toString().toUpperCase() >
            (b["reason"] + "").toString().toUpperCase()
          ) {
            return 1;
          } else {
            return -1;
          }
          // return ( (a[sortBy] > b[sortBy]) && (a['reason'] > b['reason'])) ? 1 : -1;
        } else if (sortDirection === "DESC") {
          if (
            (a[sortBy] + "").toString().toUpperCase() <
            (b[sortBy] + "").toString().toUpperCase()
          ) {
            return 1;
          } else if (
            (a["reason"] + "").toString().toUpperCase() >
            (b["reason"] + "").toString().toUpperCase()
          ) {
            return 1;
          } else {
            return -1;
          }
        }
      } else if (sortBy == "formAFlag") {
        var a = (this._getReasonCode(a) + "").toString().toUpperCase();
        var b = (this._getReasonCode(b) + "").toString().toUpperCase();
        if (sortDirection === "ASC") {
          return a > b ? 1 : -1;
        } else if (sortDirection === "DESC") {
          return a < b ? 1 : -1;
        }
      } else {
        if (sortDirection === "ASC") {
          return (a[sortBy] + "").toString().toUpperCase() >
            (b[sortBy] + "").toString().toUpperCase()
            ? 1
            : -1;
        } else if (sortDirection === "DESC") {
          return (a[sortBy] + "").toString().toUpperCase() <
            (b[sortBy] + "").toString().toUpperCase()
            ? 1
            : -1;
        }
      }
    };

    const rows =
      sortDirection === "NONE"
        ? this.state.originalRows.slice(0)
        : this.state.filteredData.sort(comparer);

    this.setState({ rows });
    this.setState({ sortBy, sortDirection });
  },

  _rowClassName({ index }) {
    if (index < 0) {
      return "headerRow";
    } else {
      return index % 2 === 0 ? "oddRow" : "evenRow";
    }
  },
  _noRowsRenderer() {
    return <div className="noRows">No rows found</div>;
  },
  _onRowCountChange(event) {
    const rowCount = parseInt(event.target.value, 10) || 0;

    this.setState({ rowCount });
  },

  _getDatum(list, index) {
    return list.get(index % list.size);
  },

  _onScrollToRowChange(event) {
    const { rowCount } = this.state;
    let scrollToIndex = Math.min(
      rowCount - 1,
      parseInt(event.target.value, 10)
    );

    if (isNaN(scrollToIndex)) {
      scrollToIndex = undefined;
    }

    this.setState({ scrollToIndex });
  },

  _getRowHeight({ index }) {
    const { list } = this.context;

    return this._getDatum(list, index).size;
  },

  _updateUseDynamicRowHeight(value) {
    this.setState({
      useDynamicRowHeight: value,
    });
  },
  // Filter the records form the Default track table
  _filterRecordsOfTheTable(value) {
    var dataSet = this.state.items;
    var rejectCodeId = [];
    dataSet = dataSet.filter(function (item) {
      var filterType = "";
      if (item.formAFlag) {
        filterType = "Form A Reason Code";
      } else if (item.formBFlag) {
        filterType = "Form B Reason Code";
      } else if (item.overrideFlag) {
        filterType = "Override";
      } else if (item.formARejectFlag && item.formBRejectFlag) {
        if (rejectCodeId.indexOf(item.id) === -1) {
          rejectCodeId.push(item.id);
          filterType = "Form A Reject Code";
        } else {
          rejectCodeId.splice(rejectCodeId.indexOf(item.id), 1);
          filterType = "Form B Reject Code";
        }
      } else if (item.formARejectFlag) {
        filterType = "Form A Reject Code";
      } else if (item.formBRejectFlag) {
        filterType = "Form B Reject Code";
      }

      if (
        item.activeRestrictionCode
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (item.reasonDescription + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        (filterType + "")
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1 ||
        item.reason
          .toString()
          .toUpperCase()
          .indexOf(value.toString().toUpperCase()) !== -1
      ) {
        return true;
      }

      if (item.activeRestrictionCode == true) {
        if (
          "Active"
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1
        ) {
          return true;
        }
      }
      if (item.activeRestrictionCode == false) {
        if (
          "Deactive"
            .toString()
            .toUpperCase()
            .indexOf(value.toString().toUpperCase()) !== -1
        ) {
          return true;
        }
      }
    });
    this.setState({ filteredData: dataSet });
  },

  _headerRenderer({ dataKey, sortBy, sortDirection }) {
    return (
      <div>
        Display Order
        {sortBy === dataKey && <SortIndicator sortDirection={sortDirection} />}
      </div>
    );
  },
  // Save New Default Track Record
  saveNewDefaultTrack: function () {
    var state = this.state;
    if (state.reason == "") {
      this.setState({ alertVisible: true });
      this.setState({ alertMessage: "Please fill out reason code field " });
    } else if (state.reasonDescription == "") {
      this.setState({ alertVisible: true });
      this.setState({
        alertMessage: "Please fill out reason description field",
      });
    } else if (
      !$("#formAReasonCode").prop("checked") &&
      !$("#formBReasonCode").prop("checked") &&
      !$("#formARejectCode").prop("checked") &&
      !$("#formBRejectCode").prop("checked") &&
      !$("#overrideCheck").prop("checked")
    ) {
      this.setState({ alertVisible: true });
      this.setState({ alertMessage: "Please select Type code" });
    } else {
      AdminActions.submitNewReasonCode({
        reason: state.reason.toString().toUpperCase(),
        reasonDescription: state.reasonDescription,
        formAReasonCode: $("#formAReasonCode").prop("checked"),
        formBReasonCode: $("#formBReasonCode").prop("checked"),
        formARejectCode: $("#formARejectCode").prop("checked"),
        formBRejectCode: $("#formBRejectCode").prop("checked"),
        overrideCode: $("#overrideCheck").prop("checked"),
        activeReasonCd: $("#activeReasonCode").prop("checked"),
        oldReason: state.oldReason,
        oldReasonDescription: state.oldReasonDescription,
        defaultID: state.defaultID,
      });
      setTimeout(
        function () {
          AdminActions.loadItems();
          items: adminStore.getItems();
          var dataSet = this.state.items;
          this.setState({ filteredData: dataSet });
          $("input:checkbox").removeAttr("checked");
          this.setState({ successUpdated: "Reason Code Updated Successfully" });
          var msg = state.defaultID == 0 ? "saved" : "updated";
          successMsg = (
            <label className="informationRequestInfoItem">
              Reason Code {state.reason.toString().toUpperCase()} {msg}{" "}
              successfully{" "}
            </label>
          );
        }.bind(this),
        150
      );
    }
  },
  // clear selected track
  clearSelectedReason: function () {
    $("input:checkbox").removeAttr("checked");
    $("input[value=active]").prop("checked", true);
    successMsg = "";
    this.setState({
      oldReason: "",
      oldReasonDescription: "",
      reason: "",
      reasonDescription: "",
      activeRestrictionCode: "",
      formAFlag: "",
      formBFlag: "",
      formARejectFlag: "",
      formBRejectFlag: "",
      overrideFlag: "",
    });
  },
  handleAlertDismiss() {
    this.setState({ alertVisible: false });
  },

  _onRowClick({ rowData }) {
    successMsg = "";
    this.setState({ oldReasonDescription: rowData.reasonDescription });
    this.setState({ oldReason: rowData.reason });
    this.setState({
      reason: rowData.reason,
      reasonDescription: rowData.reasonDescription,
      formAFlag: rowData.formAFlag,
      formBFlag: rowData.formBFlag,
      formARejectFlag: rowData.formARejectFlag,
      formBRejectFlag: rowData.formARejectFlag,
      overrideFlag: rowData.overrideFlag,
      activeRestrictionCode: rowData.activeRestrictionCode,
      defaultID: rowData.gritReasonId,
    });

    if (rowData.formAFlag == false && rowData.formBFlag == false) {
      $("input[value=FormA]").prop("checked", false);
      $("input[value=FormB]").prop("checked", false);
    }
    if (rowData.formARejectFlag == false && rowData.formBRejectFlag == false) {
      $("input[value=FormAReject]").prop("checked", false);
      $("input[value=FormBReject]").prop("checked", false);
    }
    //check Form A/B
    if (rowData.formAFlag == true) {
      $("input[value=FormA]").prop("checked", true);
      $("input[value=FormB]").prop("checked", false);
    }
    if (rowData.formBFlag == true) {
      $("input[value=FormA]").prop("checked", false);
      $("input[value=FormB]").prop("checked", true);
    }
    //check reject
    if (rowData.formARejectFlag == true) {
      $("input[value=FormAReject]").prop("checked", true);
      $("input[value=FormBReject]").prop("checked", false);
    }
    if (rowData.formBRejectFlag == true) {
      $("input[value=FormAReject]").prop("checked", false);
      $("input[value=FormBReject]").prop("checked", true);
    }

    if (rowData.formARejectFlag == true && rowData.formBRejectFlag == true) {
      $("input[value=FormAReject]").prop("checked", true);
      $("input[value=FormBReject]").prop("checked", true);
    }
    //check active/deactive
    if (rowData.activeRestrictionCode == true) {
      $("input[value=active]").prop("checked", true);
      this.setState({ defaultChecked: true });
    } else {
      $("input[value=active]").prop("checked", false);
      this.setState({ defaultChecked: false });
    }
    //Check override
    if (rowData.overrideFlag == true) {
      $("input[value=override]").prop("checked", true);
    } else {
      $("input[value=override]").prop("checked", false);
    }
  },

  onChange: function (event) {
    if (event.target) {
      // update the reactJs state for typing
      if (event.target.id == "reasonDescription") {
        this.setState({ reasonDescription: event.target.value });
      } else {
        this.setState({ reason: event.target.value });
      }
    }
  },

  radioOnChange: function (event) {
    if (event.target.id == "formAReasonCode") {
      if ($("#formAReasonCode").prop("checked") == true) {
        $("input[value=FormB]").prop("checked", false);
        $("input[value=FormAReject]").prop("checked", false);
        $("input[value=FormBReject]").prop("checked", false);
        $("input[value=override]").prop("checked", false);
      }
    } else if (event.target.id == "formBReasonCode") {
      if ($("#formBReasonCode").prop("checked") == true) {
        $("input[value=FormA]").prop("checked", false);
        $("input[value=FormAReject]").prop("checked", false);
        $("input[value=FormBReject]").prop("checked", false);
        $("input[value=override]").prop("checked", false);
      }
    } else if (event.target.id == "formARejectCode") {
      if ($("#formARejectCode").prop("checked") == true) {
        $("input[value=FormA]").prop("checked", false);
        $("input[value=FormB]").prop("checked", false);
        $("input[value=override]").prop("checked", false);
      }
    } else if (event.target.id == "formBRejectCode") {
      if ($("#formBRejectCode").prop("checked") == true) {
        $("input[value=FormA]").prop("checked", false);
        $("input[value=FormB]").prop("checked", false);
        $("input[value=override]").prop("checked", false);
      }
    } else if (event.target.id == "overrideCheck") {
      if ($("#overrideCheck").prop("checked") == true) {
        $("input[value=FormA]").prop("checked", false);
        $("input[value=FormAReject]").prop("checked", false);
        $("input[value=FormBReject]").prop("checked", false);
        $("input[value=FormB]").prop("checked", false);
      }
    } else if (event.target.id == "activeReasonCode") {
      if ($("#activeReasonCode").prop("checked") == true) {
        $("input[value=active]").prop("checked", true);
        this.setState({ defaultChecked: true });
      } else {
        $("input[value=active]").prop("checked", false);
        this.setState({ defaultChecked: false });
      }
    }
  },

  checkActiveOrDeactive({ cellData }) {
    if (cellData == true) {
      return "Active";
    } else {
      return "Deactive";
    }
  },

  _getReasonCode(rowData) {
    if (rowData.formAFlag) {
      return "Form A Reason Code";
    } else if (rowData.formBFlag) {
      return "Form B Reason Code";
    } else if (rowData.overrideFlag) {
      return "Override";
    } else if (rowData.formARejectFlag && rowData.formBRejectFlag) {
      if (rowData.reasonTypeInternal == undefined) {
        if (
          this.state.rejectReasonId.indexOf(rowData.id) === -1 &&
          (rowData.reasonTypeInternal == undefined ||
            rowData.reasonTypeInternal == "Form A Reject Code")
        ) {
          this.state.rejectReasonId.push(rowData.id);
          rowData.reasonTypeInternal = "Form A Reject Code";
          return "Form A Reject Code";
        } else if (
          rowData.reasonTypeInternal == undefined ||
          rowData.reasonTypeInternal == "Form B Reject Code"
        ) {
          this.state.rejectReasonId.splice(
            this.state.rejectReasonId.indexOf(rowData.id),
            1
          );
          rowData.reasonTypeInternal = "Form B Reject Code";
          return "Form B Reject Code";
        }
      } else {
        return rowData.reasonTypeInternal;
      }
      if (rowData.filteredValue == "" || rowData.filteredValue == undefined) {
        if (this.state.rejectReasonId.indexOf(rowData.id) === -1) {
          this.state.rejectReasonId.push(rowData.id);
          return "Form A Reject Code";
        } else {
          this.state.rejectReasonId.splice(
            this.state.rejectReasonId.indexOf(rowData.id),
            1
          );
          return "Form B Reject Code";
        }
      } else {
        if (this.state.rejectReasonId.indexOf(rowData.id) === -1) {
          this.state.rejectReasonId.push(rowData.id);
          return rowData.filteredValue;
        } else {
          return rowData.filteredValue;
        }
      }
      //	return "Test";
    } else if (rowData.formARejectFlag) {
      return "Form A Reject Code";
    } else if (rowData.formBRejectFlag) {
      return "Form B Reject Code";
    }
  },

  checkReasonType({ rowData }) {
    return this._getReasonCode(rowData);
  },

  render: function () {
    var errorMsg = "";
    var searchBox = (
      <div id="accordion" className="ui-widget-TableHeader">
        {successMsg}
        <span>
          <b> Search: </b>
        </span>
        <input
          type="text"
          onChange={(event) =>
            this._filterRecordsOfTheTable(event.target.value)
          }
        />
      </div>
    );
    if (this.state.alertVisible) {
      errorMsg = (
        <Modal
          bsSize="large"
          dialogClassName="errorModal"
          onHide={this.handleAlertDismiss}
          show={this.state.alertVisible}
        >
          <Modal.Header closeButton>
            <Modal.Title>Error</Modal.Title>
          </Modal.Header>

          <div className="modal-body">{this.state.alertMessage}</div>
          <div className="modal-footer">
            {/*
             * <Button id="confirmSubmitButton" bsStyle='danger'
             * onClick={onConfirm}>{confirmText}</Button>
             */}
            <Button id="cancelConfirmButton" onClick={this.handleAlertDismiss}>
              OK
            </Button>
          </div>
        </Modal>
      );
    }
    //To set values on click
    var reasonVal = this.state.reason;
    var reasonDesc = this.state.reasonDescription;

    var seqNo = (
      <div className="addEditTopRow">
        <label>*Reason Code:</label>
      </div>
    );
    var reasonCode = (
      <div className="addEditTopRow">
        <input
          type="text"
          id="reason"
          className="mpInput"
          name="Reason Code"
          maxLength="2"
          value={reasonVal}
          onChange={this.onChange}
          required
        />
      </div>
    );
    var trackName = (
      <div className="addEditTopRow">
        <label>*Reason Code Description:</label>
      </div>
    );
    var reasonCodeDescription = (
      <div className="addEditTopRow">
        <input
          type="text"
          id="reasonDescription"
          className="mpInput"
          name="Reason Description"
          maxLength="80"
          value={reasonDesc}
          style={{ width: "175px" }}
          onChange={this.onChange}
          required
        />
      </div>
    );
    var activeOrDeactivecheckbox = (
      <div>
        <label>
          <b>Active/Deactive:</b>{" "}
          <input
            type="checkbox"
            id="activeReasonCode"
            name="active"
            value="active"
            onChange={this.radioOnChange}
            checked={this.state.defaultChecked}
          />
        </label>
      </div>
    );
    var reasonCodeCheck = (
      <div>
        <b>Reason Code</b>
        <br />
        <label>
          Form A:{" "}
          <input
            type="checkbox"
            id="formAReasonCode"
            name="reasonCodeRadio"
            onChange={this.radioOnChange}
            value="FormA"
          />{" "}
        </label>
        <br />
        <label>
          Form B:{" "}
          <input
            type="checkbox"
            id="formBReasonCode"
            name="reasonCodeRadio"
            onChange={this.radioOnChange}
            value="FormB"
          />{" "}
        </label>
      </div>
    );
    var rejectCodeCheck = (
      <div>
        <b>Reject Code</b>
        <br />
        <label>
          Form A:{" "}
          <input
            type="checkbox"
            id="formARejectCode"
            class="rejectCodeRadio"
            onChange={this.radioOnChange}
            name="rejectCodeRadio"
            value="FormAReject"
          />
        </label>
        <br />
        <label>
          Form B:{" "}
          <input
            type="checkbox"
            id="formBRejectCode"
            class="rejectCodeRadio"
            onChange={this.radioOnChange}
            name="rejectCodeRadio"
            value="FormBReject"
          />
        </label>
      </div>
    );
    var overrideCheck = (
      <div>
        <label>
          <b>Override: </b>
          <input
            type="checkbox"
            id="overrideCheck"
            name="overrideRadio"
            onChange={this.radioOnChange}
            value="override"
          />
        </label>
      </div>
    );
    var addButton = (
      <div>
        <Button
          bsStyle="primary adminButton"
          style={{ height: "30px", width: "75px" }}
          onClick={this.saveNewDefaultTrack}
        >
          Save
        </Button>
      </div>
    );

    var clearButton = (
      <div>
        <Button
          bsStyle="primary adminButton"
          style={{ height: "30px", width: "75px" }}
          onClick={this.clearSelectedReason}
        >
          Clear
        </Button>
      </div>
    );

    const {
      disableHeader,
      useDynamicRowHeight,
      scrollToIndex,
      rowHeight,
      headerHeight,
      overscanRowCount,
      sortBy,
      sortDirection,
    } = this.state;

    var content = "Loading....";
    if (this.state.isLoading) {
      content = "Loading....";
    } else {
      if (this.state.itemType == "/reasonCodes") {
        var list = this.state.filteredData;
        content = (
          <div style={{ height: "100%" }}>
            <table width="100%">
              <tr>
                <td width="2%"></td>
                <td width="96%">
                  <div className="screenHeader">
                    <b>Reason Code</b>
                  </div>
                  <div id="accordion" className="ui-widget-header">
                    <h5>
                      <b>ADD/EDIT RECORD</b>
                    </h5>
                  </div>
                  <div id="controlLayoutGrid" role="main">
                    <table id="headers" width="100%;">
                      <thead>
                        <tr>
                          <th align="center" width="2%;" />
                          <th align="center" width="15%">
                            {activeOrDeactivecheckbox}
                          </th>
                          <th align="center" width="9%;">
                            {seqNo}
                          </th>
                          <th align="center" width="6%;">
                            {reasonCode}
                          </th>
                          <th align="center" width="8%;">
                            {trackName}
                          </th>
                          <th id="th4" width="20%;">
                            {reasonCodeDescription}
                          </th>
                          <th align="center" width="9%">
                            {reasonCodeCheck}
                          </th>
                          <th align="center" width="9%">
                            {rejectCodeCheck}
                          </th>
                          <th align="center" width="9%">
                            {overrideCheck}
                          </th>
                          <th align="center" width="2%;" />
                        </tr>
                      </thead>
                    </table>
                    <table id="footers" width="100%;">
                      <thead>
                        <tr>
                          <th align="center" width="40%;" />
                          <th align="center" width="6%;">
                            {addButton}
                          </th>
                          <th align="center" width="6%;">
                            {clearButton}
                          </th>
                          <th align="center" width="40%;" />
                        </tr>
                      </thead>
                    </table>
                  </div>
                </td>
                <td width="2%"></td>
              </tr>
              <tr>
                <td width="2%"></td>
                <td width="96%">
                  {searchBox}
                  <ContentBox className="currentSchematic">
                    <div style={{ height: "65vh" }}>
                      <AutoSizer>
                        {({ height, width }) => (
                          <Table
                            ref="Table"
                            disableHeader={disableHeader}
                            headerClassName="headerColumn"
                            scrollToIndex={scrollToIndex}
                            width={width}
                            height={height}
                            headerHeight={headerHeight}
                            overscanRowCount={overscanRowCount}
                            rowHeight={
                              useDynamicRowHeight
                                ? this._getRowHeight
                                : rowHeight
                            }
                            rowCount={list.length}
                            rowClassName={this._rowClassName}
                            noRowsRenderer={this._noRowsRenderer}
                            sort={this._sort}
                            sortBy={sortBy}
                            sortDirection={sortDirection}
                            onRowDoubleClick={this._onRowClick}
                            rowGetter={({ index }) => list[index]}
                          >
                            <Column
                              width={width * 0.18}
                              minWidth={10}
                              label="Active/Deactive"
                              dataKey="activeRestrictionCode"
                              cellRenderer={this.checkActiveOrDeactive}
                            />
                            <Column
                              width={width * 0.18}
                              minWidth={10}
                              label="Reason Code"
                              dataKey="reason"
                            />
                            <Column
                              width={width * 0.39}
                              minWidth={50}
                              label="Reason Code Description"
                              dataKey="reasonDescription"
                            />
                            <Column
                              width={width * 0.25}
                              minWidth={150}
                              label="Reason Type"
                              dataKey="formAFlag"
                              cellRenderer={this.checkReasonType}
                            />
                          </Table>
                        )}
                      </AutoSizer>
                    </div>
                  </ContentBox>
                  <div id="accordion" className="ui-widget-TableFooter">
                    {" "}
                  </div>
                </td>
                <td width="2%"></td>
              </tr>
            </table>
          </div>
        );
      }
    }

    return (
      <div className="positionUnderHeader" style={{ height: "100%" }}>
        {content}
        {errorMsg}
      </div>
    );
  },
});

export const ReasonCodeAdmin = withRouter(ReasonCodeAdminComponent);